// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/stable'
import Vue from 'vue';
import App from './App';
import router from './router';
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import firebase from 'firebase';
import './components/firebaseInit';
import store from './store'
import VueTheMask from 'vue-the-mask'
import Vuelidate from 'vuelidate'
import './plugins/axios'

import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm'
import {ValidationObserver} from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)


Vue.use(Vuelidate)



Vue.use(VueTheMask)


import './assets/scss/app.scss'


Vue.use(CoreuiVue)

let app;
firebase.auth().onAuthStateChanged(function(user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      render: h => h(App),
      router,
      store,
      icons,
      template: '<App/>',
      components: { App }
    }).$mount('#app')
  }
});
